module.exports = __webpack_public_path__ + "media/images/new/member_testimonial_main-7fa0248708cfc59b8c139ec0f77363c1.jpg";